const POLYGON_MUMBAI_ADDRESSES: {[key: string]: `0x${string}`} = {
    aggregatorV3: '0x90fF98975aE9cFB6cCe2eF179e41C87913820E6b',
    blockPotToken: '0xB62aFf72a4A153b573B946E37eEf5B1F6b0e0Eb6',
    configManager: '0xd228B1f81FC6Efc1725E63bED9cBCFeb40F3bbD1',
    link: '0x222A58A3d711894258228F46994094C7D4E7b8b6',
    lottery: '0x8933A9eb812FF88aD9f2Fe4C278C5A1f02209C7B',
    lotteryRandomNumberProvider: '0x77be1c35De482771f466a212A5EB926546f67a18',
    referralManager: '0x7D96A1D011cED4Df1d4a268A17fd2Ab713f3F734',
    rewardTracker: '0x775517F7C504E6Cf13A99A47819287580AecCF1a',
    weth: '0xf9a6fEa3D59cb3A2c62D8E2A55d3266Ec39FC15e',
    wrapper: '0xe12f50cbD5400C0B191925fC24AF02A75Ffc403f'
}

export default POLYGON_MUMBAI_ADDRESSES